import React from 'react';
import Logo from '../assets/img/logo_hiball.png';
import SearchBar from "../components/searchBar/SearchBarForMain";
import Footer from "../components/footer/Footer";

function MainPage() {
    return (
        <>
            <div className="mainPageContainer">
                <div className="mainPageWrap">
                    <div className="logoWrap">
                        <img src={Logo} alt="#"/>
                    </div>
                    <div className="pageTitle">
                        <span>H.I.T.S.</span>
                        <span>Digest</span>
                    </div>
                    <div className="searchBarBox">
                        <SearchBar/>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default MainPage;